module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Position-9a50c0d8e58a2aa4707d884a21317094.svg";